import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'DOCUMENTS_TYPES_SHOW', {
  TITLE: 'Document type',
  NAME: 'Name',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'DOCUMENTS_TYPES_SHOW', {
  TITLE: 'Tipo de documento',
  NAME: 'Nombre',
  LOADING: 'Cargando...',
});
